<template>
  <div class="nav"> 
<van-nav-bar class="nav"
  :title=title
  left-arrow
  left-text="返回"
  :fixed =fixed
  :right-text="righttext"
  @click-left="onClickLeft"
/>
    </div>
</template>

<script>
export default {
   props: {
    title: {
      type: String,
      default: 'title'
    },
    fixed:{
        type:Boolean,
        default:false,
    },
    righttext:{
     type:String,
        default:"",
    },
    callbackLeft: {
      type: Function,
      default: () => {}
    }
  },
methods:{
  
    onClickLeft() {
      this.$router.go(-1);
      this.callbackLeft()
    },
}
}
</script>

<style>

.van-nav-bar .van-icon{
    color: #f8fcff;
}
.van-nav-bar__title{
    color: #f8fcff;
}
.van-nav-bar__text{
  color: #f8fcff;
  font-size: 14px;
}

.van-nav-bar{
    background-color: #5B8DF6;
}
.nav{
     letter-spacing: 5px;
}
.van-nav-bar__left, .van-nav-bar__right{
  font-size: 25px;
}
</style>